import { Component, OnInit } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-psd-public-utility-data',
  templateUrl: './psd-public-utility-data.component.html',
  styleUrls: ['./psd-public-utility-data.component.scss']
})
export class PsdPublicUtilityDataComponent implements OnInit {

  displayedColumns: string[] = ['name', 'tbd', 'action'];
  dataSource = [
    { name: '', tdb: '' },
    { name: '', tdb: '' }
  ];

  displayedColumnsEVU: string[] = ['name', 'zip', 'city'];
  dataSourceEVU = [
    { name: '', zip: '', city: '' },
    { name: '', zip: '', city: '' }
  ];

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
